import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    heightPercentageToDP,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const PHONE_TOP_PADDING = 44;

const styles = StyleSheet.create({
    container: { flex: 1 },
    dialog: {
        backgroundColor: COLOR.BLACK,
        paddingHorizontal: 16,
    },
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    closeButtonSafeArea: {
        position: 'absolute',
        right: isPhone ? widthPercentageToDP(16) : 24,
    },
    closeButton: {
        position: 'absolute',
        right: isPhone ? widthPercentageToDP(16) : 24,
        width: 40,
        height: 40,
    },
    titleStyle: {
        fontSize: isTabletOrWeb ? 32 : 24,
    },
    closeSvg: {
        width: 16,
        height: 16,
    },
    descriptionContentContainer: {
        flexGrow: isTabletOrWeb ? 0 : 1,
    },
    descriptionContainer: {
        marginBottom: heightPercentageToDP(48),
    },
    description: {
        maxWidth: 724,
        marginTop: 8,
        fontSize: isTabletOrWeb ? undefined : 14,
    },
    profilesWrapper: {
        flexGrow: 1,
        alignSelf: 'center',
        marginTop: isPhone ? PHONE_TOP_PADDING : 0,
    },
    profilesContainer: {
        marginTop: isPhone ? -PHONE_TOP_PADDING : 0,
        marginBottom: isPhone ? 84 : 0,
        minHeight: isTablet ? 170 : 'auto',
        ...(isTablet && { maxHeight: 175 }),
    },
    profilesContentContainer: {
        flexGrow: 1,
        alignItems: isPhone ? 'center' : 'flex-start',
        justifyContent: 'center',
    },
    buttonText: {
        color: COLOR.BLACK,
    },
    buttonBackground: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 40,
        backgroundColor: COLOR.BLACK,
    },
});

export default styles;
